(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_peana-suplemento"] && !Shopify.designMode) return;
  try {
    // Este bloque de JS se inserta como script clásico, no como módulo ES, así
  // que aquí no se puede importar StandardEvents de '@shopify/events' (rompe
  // con "Cannot use import statement outside a module"). Se usa el valor
  // literal del evento en su lugar: 'shopify:cart:lines-update' (comprobado
  // en tiempo de ejecución).
  const CART_LINES_UPDATE_EVENT = 'shopify:cart:lines-update';

  if (!customElements.get('peana-suplemento-component')) {
    class PeanaSuplementoComponent extends HTMLElement {
      connectedCallback() {
        this.radios = Array.from(this.querySelectorAll('[data-radio]'));
        this.deselectButton = this.querySelector('[data-deselect]');
        this.avisoEl = this.querySelector('[data-aviso]');
        this.totalEl = this.querySelector('[data-total]');
        this.formId = this.dataset.formId;
        this.currency = this.dataset.currency;
        this.locale = this.dataset.locale;
        this.totalLabel = this.dataset.totalLabel;
        this.armado = null;
        this.desarmarTimeout = null;

        // El precio base se lee del propio texto ya pintado en pantalla en
        // vez de escuchar el sistema de eventos de cambio de variante: así
        // el total se mantiene correcto pase lo que pase (cambio de tamaño,
        // de color...) sin depender de cómo lo actualice el tema por dentro.
        this.priceEl = this.closest('.product-details')?.querySelector('.price');
        if (this.priceEl) {
          this.priceObserver = new MutationObserver(() => this.updateTotal());
          this.priceObserver.observe(this.priceEl, { childList: true, characterData: true, subtree: true });
        }

        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.updateDeselectVisibility());
        });

        if (this.deselectButton) {
          this.deselectButton.addEventListener('click', () => {
            this.radios.forEach((radio) => {
              radio.checked = false;
            });
            this.updateDeselectVisibility();
          });
        }

        // No se toca el envío del formulario de compra en absoluto (dos
        // intentos previos de interceptarlo salieron mal: un POST paralelo a
        // /cart/add.js se pisa con el del formulario y se pierde uno de los
        // dos artículos, y reenviar el formulario a mano duplicaba la línea
        // principal). En vez de eso: se "arma" al pulsar el botón de compra
        // si hay una miniatura elegida, y solo cuando el carrito confirma
        // que esa compra ya se ha completado se añade la peana como una
        // segunda petición independiente, sin solaparse con la primera.
        document.addEventListener(
          'click',
          (event) => {
            const button = event.target instanceof Element ? event.target.closest('button') : null;
            if (!button) return;

            const form = button.form || button.closest('form');
            if (!form || form.getAttribute('id') !== this.formId) return;

            const selected = this.radios.find((radio) => radio.checked);
            if (!selected) return;

            this.armado = selected.value;
            clearTimeout(this.desarmarTimeout);
            this.desarmarTimeout = setTimeout(() => {
              this.armado = null;
            }, 8000);
          },
          true
        );

        document.addEventListener(CART_LINES_UPDATE_EVENT, (event) => {
          if (!this.armado) return;
          const variantId = this.armado;
          this.armado = null;
          clearTimeout(this.desarmarTimeout);

          event.promise
            ?.then((result) => {
              if (result?.detail?.didError) return;
              this.addPeana(variantId);
            })
            .catch(() => {});
        });
      }

      updateDeselectVisibility() {
        if (!this.deselectButton) return;
        this.deselectButton.hidden = !this.radios.some((radio) => radio.checked);
        this.updateTotal();
      }

      updateTotal() {
        if (!this.totalEl) return;
        const selected = this.radios.find((radio) => radio.checked);

        if (!selected || !this.priceEl) {
          this.totalEl.hidden = true;
          return;
        }

        const baseCents = Math.round(this.parseMoney(this.priceEl.textContent) * 100);
        const peanaCents = Number(selected.dataset.price) || 0;

        this.totalEl.hidden = false;
        this.totalEl.textContent = `${this.totalLabel} ${this.formatMoney(baseCents + peanaCents)}`;
      }

      /** Convierte un precio ya formateado en pantalla (p. ej. "€1.234,56") a número. */
      parseMoney(text) {
        const cleaned = (text || '').replace(/[^0-9.,]/g, '');
        const lastComma = cleaned.lastIndexOf(',');
        const lastDot = cleaned.lastIndexOf('.');
        const decimalIndex = Math.max(lastComma, lastDot);

        if (decimalIndex === -1) return parseInt(cleaned, 10) || 0;

        const intPart = cleaned.slice(0, decimalIndex).replace(/[.,]/g, '') || '0';
        const decPart = (cleaned.slice(decimalIndex + 1).replace(/[^0-9]/g, '') + '00').slice(0, 2);

        return parseFloat(`${intPart}.${decPart}`) || 0;
      }

      formatMoney(cents) {
        try {
          // Mismo criterio que el resto de la tienda (money_without_trailing_zeros):
          // "80 €" si el importe es redondo, "80,50 €" si lleva céntimos.
          const redondo = cents % 100 === 0;
          return new Intl.NumberFormat(this.locale || 'es-ES', {
            style: 'currency',
            currency: this.currency || 'EUR',
            minimumFractionDigits: redondo ? 0 : 2,
            maximumFractionDigits: redondo ? 0 : 2,
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }

      addPeana(variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('add-peana-failed');
          })
          .catch(() => {
            if (!this.avisoEl) return;
            this.avisoEl.hidden = false;
            this.avisoEl.textContent =
              'No se ha podido añadir la peana al pedido. Escríbenos y la añadimos a mano.';
          });
      }
    }

    customElements.define('peana-suplemento-component', PeanaSuplementoComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_subida-foto"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subida-foto-component')) {
    class SubidaFotoComponent extends HTMLElement {
      connectedCallback() {
        // Delegación de eventos en la raíz: ver el comentario del bloque
        // Liquid sobre por qué no se guardan referencias fijas a los hijos.
        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleChange);
        this.addEventListener('dragover', this.handleDragOver);
        this.addEventListener('dragenter', this.handleDragOver);
        this.addEventListener('dragleave', this.handleDragLeave);
        this.addEventListener('dragend', this.handleDragLeave);
        this.addEventListener('drop', this.handleDrop);

        this.helperText = this.dataset.helperText || '';
        this.laterLinkText = this.dataset.laterLinkText || '';
        this.laterConfirmText = this.dataset.laterConfirmText || '';
        this.laterUndoText = this.dataset.laterUndoText || '';

        const template = this.querySelector('template');
        this.maxBytes = Number(template?.getAttribute('data-max-size-bytes')) || 20 * 1024 * 1024;
        this.errorSizeText =
          template?.content.querySelector('[data-error-size-text]')?.textContent ||
          'El archivo pesa demasiado.';

        this.later = false;
        this.renderApoyo();
      }

      handleClick = (event) => {
        if (event.target.closest('[data-remove]')) {
          this.clearFile();
          return;
        }
        if (event.target.closest('[data-later-toggle]')) {
          event.preventDefault();
          this.setLaterMode(true);
          return;
        }
        if (event.target.closest('[data-later-undo]')) {
          event.preventDefault();
          this.setLaterMode(false);
        }
      };

      handleChange = (event) => {
        if (event.target.matches('[data-input]')) {
          this.handleFiles(event.target.files);
        }
      };

      handleDragOver = (event) => {
        if (!event.target.closest('[data-dropzone]')) return;
        event.preventDefault();
        this.querySelector('[data-dropzone]')?.classList.add('is-dragover');
      };

      handleDragLeave = () => {
        this.querySelector('[data-dropzone]')?.classList.remove('is-dragover');
      };

      handleDrop = (event) => {
        if (!event.target.closest('[data-dropzone]')) return;
        event.preventDefault();
        this.querySelector('[data-dropzone]')?.classList.remove('is-dragover');
        const files = event.dataTransfer && event.dataTransfer.files;
        if (!files || !files.length) return;
        const input = this.querySelector('[data-input]');
        input.files = files;
        this.handleFiles(files);
      };

      handleFiles(fileList) {
        const errorEl = this.querySelector('[data-error]');
        errorEl.hidden = true;
        const file = fileList && fileList[0];
        if (!file) return;

        if (file.size > this.maxBytes) {
          errorEl.textContent = this.errorSizeText;
          errorEl.hidden = false;
          this.clearFile();
          return;
        }

        this.querySelector('[data-preview-name]').textContent = file.name;
        const previewImg = this.querySelector('[data-preview-img]');
        const reader = new FileReader();
        reader.onload = (event) => {
          previewImg.src = event.target.result;
        };
        reader.readAsDataURL(file);

        this.querySelector('[data-preview]').hidden = false;
        this.querySelector('[data-dropzone]').hidden = true;
      }

      clearFile() {
        const input = this.querySelector('[data-input]');
        input.value = '';
        this.querySelector('[data-preview]').hidden = true;
        this.querySelector('[data-dropzone]').hidden = false;
        this.querySelector('[data-error]').hidden = true;
      }

      setLaterMode(enabled) {
        this.later = enabled;
        this.classList.toggle('subida-foto--later', enabled);
        this.querySelector('[data-input]').required = !enabled;
        this.querySelector('[data-later-field]').disabled = !enabled;
        if (enabled) this.clearFile();
        this.renderApoyo();
      }

      renderApoyo() {
        const apoyo = this.querySelector('[data-apoyo]');
        apoyo.textContent = '';

        if (this.later) {
          apoyo.append(this.laterConfirmText + ' ');
          const undo = document.createElement('button');
          undo.type = 'button';
          undo.className = 'subida-foto__enlace';
          undo.textContent = this.laterUndoText;
          undo.setAttribute('data-later-undo', '');
          apoyo.append(undo);
        } else {
          apoyo.append(this.helperText + ' ');
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'subida-foto__enlace';
          toggle.textContent = this.laterLinkText;
          toggle.setAttribute('data-later-toggle', '');
          apoyo.append(toggle);
        }
      }
    }

    customElements.define('subida-foto-component', SubidaFotoComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
